import {
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    EDIT_LANGUAGE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove, update } from "firebase/database";
import { getLangKey } from "../other/getLangKey";
import { withFallbackTranslations } from "../other/fallbackTranslations";

export const fetchLanguages = () => (dispatch) => {

    const {
        languagesRef
    } = firebase;

    dispatch({
        type: FETCH_LANGUAGE,
        payload: null
    });
    onValue(languagesRef, snapshot => {
        if (snapshot.val()) {
            const data = snapshot.val();
            let defLang = null;
            const arr = Object.keys(data).map(i => {
                data[i].id = i;
                if(data[i].default){
                    defLang = withFallbackTranslations(data[i].langLocale, data[i].keyValuePairs);
                }
                return data[i]
            });
            dispatch({
                type: FETCH_LANGUAGE_SUCCESS,
                payload: {
                    defaultLanguage: defLang,
                    langlist: arr
                }
            });
        } else {
            dispatch({
                type: FETCH_LANGUAGE_FAILED,
                payload: "No Languages available."
            });
        }
    });
};

export const editLanguage = (lang, method) => (dispatch) => {
    const {
        languagesRef,
        languagesEditRef
    } = firebase;
    dispatch({
        type: EDIT_LANGUAGE,
        payload: { lang, method }
    });
    const { tableData, ...clean } = lang || {};
    if (method === 'Add') {
        return push(languagesRef, clean);
    } else if (method === 'Delete') {
        return remove(languagesEditRef(clean.id));
    } else {
        return set(languagesEditRef(clean.id), clean);
    }
}

/** Traduce un texto con la función `gettranslation` (solo administradores). Devuelve null si falla. */
export const translateText = async (str, from, to) => {
    const { auth, config } = firebase;
    try {
        const idToken = auth.currentUser ? await auth.currentUser.getIdToken() : null;
        const qs = `str=${encodeURIComponent(str)}&from=${encodeURIComponent(from || '')}&to=${encodeURIComponent(to || '')}`;
        const response = await fetch(`https://us-central1-${config.projectId}.cloudfunctions.net/gettranslation?${qs}`, {
            method: 'GET',
            headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
        });
        const json = await response.json();
        return json && typeof json.text === 'string' && json.text ? json.text : null;
    } catch (err) {
        return null;
    }
}


export const convertLanguage = async (word, userLangLocale)=>{
    const {
        languagesRef,
        langEditRef,
    } = firebase;
    
    let langKey = getLangKey(word);

    onValue(languagesRef, async (snapshot) => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const langLocaleArr = Object.keys(data).map(i => {
                data[i].id = i;
                return {langLocale : data[i].langLocale, id: data[i].id}
            });

            let defLangLocale = "";

            if(userLangLocale){
                defLangLocale = userLangLocale;
            }else{
                const defLocale = Object.keys(data).filter(i => {
                    data[i].id = i;
                    return data[i].default === true;
                })[0];

                defLangLocale = data[defLocale].langLocale;
            }

            for (let j = 0; j < langLocaleArr.length; j++){
                try{
                    if(langLocaleArr[j].langLocale === defLangLocale){
                        update(langEditRef(langLocaleArr[j].id),{[langKey]:word})
                    }else{
                        const text = await translateText(word, defLangLocale, langLocaleArr[j].langLocale);
                        update(langEditRef(langLocaleArr[j].id),{[langKey]: text || word})
                    }
                  }
                  catch(err) {
                    console.log("errror occured in language add", err)
                  };
            }
        }
    }, {onlyOnce: true});

}